// src/components/LastPageModal/LastPageModal.js

import React from 'react';
import './LastPageModal.css';
import cursorDefault from '../../assets/cursors/cursor-default.png';
import cursorPointer from '../../assets/cursors/cursor-pointer.png';

const LastPageModal = ({ closeModal }) => {
  const modalCursorDefault = `url(${cursorDefault}) 2 2, default`;
  const modalCursorPointer = `url(${cursorPointer}) 6 2, pointer`;

  return (
    <div
      className="modal-overlay"
      style={{ cursor: modalCursorDefault }}
    >
      <div
        className="base-modal last-page-modal"
        style={{ cursor: modalCursorDefault }}
      >
        <div
          className="last-page-modal-content"
          style={{ cursor: modalCursorDefault }}
        >
          <p>Computer says no!</p>
          <button
            className="close-modal-btn"
            onClick={closeModal}
            aria-label="Close Last Page Modal"
            style={{ cursor: modalCursorPointer }}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default LastPageModal;